import { ArrowUp, MessageCircle, Phone } from 'lucide-react';

export default function FloatingContactButtons() {
  function scrollTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
  return (
    <div className="pointer-events-none fixed bottom-6 right-6 z-30 flex flex-col items-end gap-3">
      <a
        href="https://wa.me/"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="WhatsApp"
        className="pointer-events-auto inline-flex h-11 w-11 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg"
      >
        <MessageCircle size={20} />
      </a>
      <a
        href="tel:+910000000000"
        aria-label="Call"
        className="pointer-events-auto inline-flex h-11 w-11 items-center justify-center rounded-full bg-[var(--color-primary)] text-white shadow-lg"
      >
        <Phone size={20} />
      </a>
      <button
        type="button"
        onClick={scrollTop}
        aria-label="Scroll to top"
        className="pointer-events-auto inline-flex h-11 w-11 items-center justify-center rounded-full border border-[var(--color-border)] bg-[var(--color-bg-card)] shadow-lg"
      >
        <ArrowUp size={18} />
      </button>
    </div>
  );
}
